// Every caller of the openInNewWindow port reaches it from an HTTP response, because the
// file URL has to be fetched before it can be opened. No user gesture is live by then, so
// Safari (mobile Safari especially) blocks the pop-up and returns null, and the member sees
// nothing happen. Fall back to the current tab, which is never pop-up blocked.
//
// Do not pass "noopener": it makes window.open return null even when it succeeds, which
// would send us down the fallback on top of a tab that already opened.
function openUrl(url, win) {
  const newPage = win.open(url, "_blank");
  if (!newPage) {
    win.location.assign(url);
  }
}

const NavigationPort = {
  openUrl: openUrl,

  add: function (app) {
    // Inform app of browser navigation (the BACK and FORWARD buttons)
    window.addEventListener("popstate", function () {
      app.ports.onUrlChange.send(location.href);
    });

    // Change the URL upon request, inform app of the change.
    app.ports.pushUrl.subscribe(function (url) {
      history.pushState({}, "", url);
      app.ports.onUrlChange.send(location.href);
    });

    // Intercept link clicks to change the location without refreshing the page
    document.addEventListener("click", function (event) {
      const { target } = event;
      if (event.ctrlKey || event.metaKey) {
        return;
      }
      const isLocalHref = (targetA) => {
        return targetA.host == location.host;
      };
      const linkElement = target.localName == "a" ? target : target.closest("a");
      if (linkElement && linkElement.href && isLocalHref(linkElement) && linkElement.target !== "_blank") {
        event.preventDefault();
        history.pushState({}, "", linkElement.href);
        app.ports.onUrlChange.send(linkElement.href);
      }
    });

    if (app.ports.openInNewWindow) {
      app.ports.openInNewWindow.subscribe((url) => {
        openUrl(url, window);
      });
    }

    if (app.ports.replaceUrl) {
      app.ports.replaceUrl.subscribe((url) => {
        history.replaceState({}, "", url);
      });
    }
  },
};

module.exports = NavigationPort;
